<div class="tab-content-container mt-3 mb-2">
    @if (showGrid && gridConfig) {
    <div [style.height.px]="gridHeight">
        <inavista-grid #shipmentAdjustmentExceptionGrid class="so-popup-grid"
            [config]="gridConfig"
            (hyperlinkClick)="onHyperlinkClick($event)"
            (exportRequested)="onExportRequested()" />
    </div>
    }
</div>

@if (linkedPopupData) {
<app-linked-popup-opener

    [data]="linkedPopupData"
    (onPopupClose)="linkedPopupData = null;"
></app-linked-popup-opener>
}
